// extracted by mini-css-extract-plugin
module.exports = {"root":"Graph_root__36Rsl","header":"Graph_header__10oA_","options":"Graph_options__TRGww"};